import { usePage } from "@inertiajs/react"
import { UserLayout } from "@/components/layouts/user-layout"
import { DirectoryScreen } from "@/features/user/directory-screen"
import type { DirectoryLocation } from "@/features/user/types"

type Props = {
  query: string
  results: DirectoryLocation[]
  nearby: boolean
}

/**
 * Home is the restaurant directory. Picking one starts a pickup context and
 * lands the diner on that restaurant's menu, so there is nothing else to offer
 * here — the quick actions and the visit history it used to carry either
 * duplicated that or pointed at screens the diner cannot use yet.
 */
export default function UserDashboardsShow() {
  const { query, results, nearby } = usePage<Props>().props

  return (
    <UserLayout wide>
      {/* `/dashboard`, not `/`. The root is temporarily `redirect("/about")` to hide an
          empty directory, so a search against `/` 302s away on every keystroke. When
          that redirect is reverted this goes back to `/` — see the revert note in
          config/routes.rb. */}
      <DirectoryScreen query={query} results={results} nearby={nearby} searchPath="/dashboard" />
    </UserLayout>
  )
}
